import { Input, Label } from '@windmill/react-ui';
import { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import EditableForm from 'src/models/editableForm';
import EditableInput from 'src/components/_common/EditableInput/EditableInput';

const AdminFormQuestionOptions = ({ form: form, handleSetFormHelpText: handleSetFormHelpText }: {form: EditableForm, handleSetFormHelpText: (helpText: string) => void}) => {
  const { formatMessage } = useIntl();
  const [showCommentField, toggleShowCommentField] = useState<boolean>(!!form?.helpText);

  useEffect(() => {
    if (!showCommentField)handleSetFormHelpText('');
  }, [showCommentField]);

  return (
    <div className="contents">
      <Label>
        <Input
          type="checkbox"
          defaultChecked={!!form?.helpText}
          value="supervisor-text"
          onChange={() => toggleShowCommentField(!showCommentField)}
          onPointerEnterCapture={() => {}}
          onPointerLeaveCapture={() => {}}
          css=""
          crossOrigin={undefined}
        />
        <span className="text-black"><FormattedMessage id="form-introduction-text" /></span>
      </Label>
      {showCommentField
        && (
        <div className="mt-4 block text-sm text-gray-700">
          <span><FormattedMessage id="edit-form-introduction-text" /></span>
          <EditableInput
            text={form?.helpText}
            active
            markdownToolbar
            ariaLabel={formatMessage({ id: 'edit-form-introduction-text' })}
            onChangeHandler={value => handleSetFormHelpText(value)}
          />
        </div>
        )}
    </div>
  );
};

export default AdminFormQuestionOptions;
